export const GEOGRID_INSIGHTS: string[] = [
  "Businesses ranked in the Google Map Pack get 44% of all clicks for local searches.",
  "76% of people who search for something nearby visit a related business within a day.",
  "Listings with 5+ photos get 35% more clicks to their website than those without.",
  "The average Google Business Profile is viewed 1,260 times per month.",
  "Businesses that respond to reviews see 12% more reviews on average.",
  "92% of searchers pick businesses on the first page of local results.",
  "GBP listings with a description get 2.7x more direction requests.",
  "Adding weekly Google Posts can lift profile views by up to 30%.",
  "\"Near me\" searches have grown 500% in the last few years.",
  "Listings that appear in the 3-pack get 700% more clicks than those ranked 4–10.",
  "88% of mobile local searches end in a call or visit within 24 hours.",
  "The top-3 ranked business in a market typically captures over half the local revenue.",
  "Google uses 200+ ranking signals — proximity is just one of them.",
  "Categories matter: changing your primary category can move you 5+ spots up or down.",
  "Service-area businesses with defined service zones get 17% more leads on average.",
];
